<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}采购计划</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">采购基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="采购计划单号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成采购单号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属科室" prop="deptName">
                <el-select :disabled="!editMode || Boolean(form.id)" v-model="form.deptName" style="width: 90%" filterable placeholder="请选择采购科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="采购负责人" prop="purchaseUserName">
                <el-select :disabled="!editMode || Boolean(form.id)" v-model="form.purchaseUserName" style="width: 90%" filterable placeholder="请选择采购负责人" :filter-method="getUsersByDept" @change="userChange">
                  <el-option v-for="item in STATIC_DeptUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总数量" prop="totalNumber">
                <el-input-number disabled v-model="form.totalNumber" :min="0" :precision="2" :controls="false" placeholder="根据详细信息数量求和汇总" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总金额" prop="totalAmount">
                <el-input-number disabled v-model="form.totalAmount" :min="0" :precision="4" :controls="false" placeholder="根据详细信息金额求和汇总" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode || Boolean(form.id)" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 20px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">采购详细信息</span>
          </div>
          <div v-if="editMode && optype != 'apply'" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>
          <el-table :data="form.details" border style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange"  stripe :header-cell-style="{ background: '#DDEBFF' }" :default-expand-all="true" :row-class-name="getRowClass">
            <el-table-column type="expand">
              <template slot-scope="scope2" v-if="scope2.row.details">
                <el-table :data="scope2.row.details" border class="two-list" stripe :header-cell-style="{ background: '#DDEBFF' }" :row-style="{ background: '#F9F9F9' }">
                  <el-table-column v-if="editMode && optype == 'claim'" type="selection" fixed width="50" align="center" />
                  <el-table-column show-overflow-tooltip :label="optype == 'claim' ? '请领科室' : '请购科室'" align="center" min-width="140" prop="deptName" />
                  <el-table-column show-overflow-tooltip :label="optype == 'claim' ? '请领人' : '请购人'" align="center" min-width="140" prop="applyUserName" />
                  <el-table-column show-overflow-tooltip :label="optype == 'claim' ? '申请日期' : '创建日期'" align="center" min-width="140" prop="date">
                    <template slot-scope="scope">
                      <div>
                        {{ parseTime(new Date(scope.row.date), "{y}-{m}-{d}") }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="optype == 'claim'" show-overflow-tooltip label="责任科室" align="center" min-width="140" prop="dutyDeptName" />
                  <el-table-column v-if="optype == 'claim'" show-overflow-tooltip label="请领数量" align="center" min-width="140" prop="claimNumber" :formatter="toDecimal2" />
                  <el-table-column v-if="optype == 'claim'" show-overflow-tooltip label="已领数量" align="center" min-width="140" prop="receivedNumber" :formatter="toDecimal2" />
                  <el-table-column show-overflow-tooltip label="采购数量" align="center" min-width="140" prop="number">
                    <template slot-scope="scopeNum2">
                      <template v-if="editMode">
                        <el-input-number v-model="scopeNum2.row.number" :min="0" :precision="2" :controls="false" style="width: 100%" @change="sonNumChange(scope2.row)"></el-input-number>
                      </template>
                      <template v-else>
                        {{ toDecimal2(null, null, scopeNum2.row.number) }}
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip label="采购价格" align="center" min-width="140" prop="price" :formatter="toDecimal4" />
                  <el-table-column show-overflow-tooltip label="备注" align="center" min-width="140" prop="remark">
                    <template slot-scope="scope">
                      <template v-if="editMode">
                        <el-input v-model="scope.row.remark" />
                      </template>
                      <template v-else>
                        {{ scope.row.remark }}
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column v-if="editMode && optype != 'apply'" show-overflow-tooltip type="selection" fixed width="50" align="center" />
            <el-table-column v-if="optype != 'apply'" show-overflow-tooltip label="资产编号" align="center" min-width="140" prop="fixedAssetNo" />
            <el-table-column show-overflow-tooltip label="资产名称" align="center" min-width="130" prop="fixedAssetName" />
            <!-- <el-table-column
              label="资产卡号"
              align="center"
              min-width="200"
              prop="fixedAssetCards"
            >
              <template slot-scope="scope">
                <el-tooltip
                  effect="light"
                  placement="bottom"
                  popper-class="tooltip-content"
                >
                  <div slot="content" class="">
                    <div
                      class="tooltip-text"
                      v-for="item in scope.row.assetCardInfos"
                      :key="item.id"
                    >
                      {{ item.no }}
                    </div>
                  </div>
                  <span class="td-overflow-hidden">{{
                    scope.row.assetCardInfos
                      ? scope.row.assetCardInfos.map((e) => e.no).join(";")
                      : ""
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column> -->
            <el-table-column show-overflow-tooltip label="规格型号" align="center" min-width="130" prop="specName" />
            <el-table-column v-if="optype != 'apply'" show-overflow-tooltip label="单位" align="center" min-width="80" prop="unitName" />
            <!-- <el-table-column v-if="optype != 'apply'" show-overflow-tooltip label="品牌" align="center" min-width="100" prop="brandName" /> -->
            <el-table-column v-if="optype != 'apply'" show-overflow-tooltip label="生产厂家" align="center" min-width="130" prop="manufacturerName" />
            <el-table-column v-if="optype != 'apply'" show-overflow-tooltip label="供应商" align="center" min-width="130" prop="supplierName" />
            <el-table-column show-overflow-tooltip label="资产类型" align="center" min-width="130" prop="assetTypeName" />
            <el-table-column show-overflow-tooltip label="产地类型" align="center" min-width="80" prop="productionPlaceName" />
            <el-table-column v-if="optype != 'apply'" show-overflow-tooltip label="财务分类" align="center" min-width="80" prop="financeTypeName" />
            <el-table-column v-if="optype == 'claim'" show-overflow-tooltip label="请领数量" align="center" min-width="140" prop="claimNumber" :formatter="toDecimal2" />
            <el-table-column v-if="optype == 'apply'" show-overflow-tooltip label="请购数量" align="center" min-width="140" prop="claimNumber" :formatter="toDecimal2" />
            <el-table-column v-if="optype == 'claim'" show-overflow-tooltip label="已领数量" align="center" min-width="140" prop="receivedNumber" :formatter="toDecimal2" />
            <el-table-column v-if="optype != 'apply'" show-overflow-tooltip label="剩余库存" align="center" min-width="120" prop="stockNumber" :formatter="toDecimal2" />
            <el-table-column show-overflow-tooltip label="采购总量" align="center" :min-width="80" prop="number" :formatter="toDecimal2" />
            <!-- <el-table-column
              show-overflow-tooltip
              label="预计单价"
              align="center"
              min-width="120"
              prop="price"
              :formatter="toDecimal4"
            /> -->
            <el-table-column show-overflow-tooltip label="预计单价" align="center" min-width="140" prop="price">
              <template slot-scope="scopeNum">
                <template v-if="editMode">
                  <el-input-number v-model="scopeNum.row.price" :min="0" :precision="4" :controls="false" style="width: 100%" @change="autoAmount2(scopeNum.row)"></el-input-number>
                </template>
                <template v-else>
                  {{ toDecimal4(scopeNum.row, "", scopeNum.row.price) }}
                </template>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="采购总价" align="center" min-width="120" prop="amount" :formatter="toDecimal4" />
          </el-table>
        </div>

        <!-- <AssetInfoEdit
          ref="AssetInfoEditRef"
          :data="form.details"
          :editMode="editMode"
          :ParentForm="form"
          :FixedAssetParam="{ deptId: form.deptId }"
          @autoTotalAmount="autoTotalAmount"
          :isPurchase="true"
          typeName="采购"
        >
        </AssetInfoEdit> -->

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">
        取 消
      </el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>

    <el-dialog title="资产信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
      <el-form label-position="top" ref="childForm" :model="childForm" :rules="childFormRules">
        <el-row>
          <el-col :span="6">
            <el-form-item label="资产编号" prop="fixedAssetNo">
              <SelectTable :disabled="!editMode" :columns="stockColumns" :placeholder="'请选择资产编号'" :innerName="childForm.fixedAssetNo" :dataList="STATIC_Stocks" @filterMethod="getFixedAssetList" @change="selectAsset" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="资产名称" prop="fixedAssetName">
              <el-input disabled v-model="childForm.fixedAssetName" placeholder="请填写资产名称" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="资产卡号" prop="assetCardNoArr">
              <el-select
                :disabled="!editMode"
                v-model="childForm.assetCardNoArr"
                placeholder="请选择资产卡号"
                :multiple="true"
                collapse-tags
                :filter-method="getAssetCards"
                @change="cardChange"
                style="width: 100%"
              >
                <el-option
                  v-for="item in STATIC_AssetCards"
                  :key="item.id"
                  :label="item.no"
                  :value="item.no"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="规格型号" prop="specName">
              <el-input disabled v-model="childForm.specName" placeholder="系统自动带出规格型号" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="品牌" prop="brandName">
              <el-input disabled v-model="childForm.brandName" placeholder="系统自动带出品牌" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产厂家" prop="manufacturerName">
              <el-input disabled v-model="childForm.manufacturerName" placeholder="系统自动带出生产厂家" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="供应商" prop="supplierName">
              <el-input disabled v-model="childForm.supplierName" placeholder="系统自动带出供应商" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="资产类型" prop="assetTypeName">
              <el-input disabled v-model="childForm.assetTypeName" placeholder="系统自动带出资产类型" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产地类型" prop="productionPlaceName">
              <el-input disabled v-model="childForm.productionPlaceName" placeholder="系统自动带出产地类型" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="库存数量" prop="stockNumber">
              <el-input-number disabled v-model="childForm.stockNumber" :min="0" :precision="2" :controls="false" placeholder="系统自动带出库存数量" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="采购总量" prop="number">
              <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" :controls="false" placeholder="请填写采购总量" @change="childNumberChange" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="预计单价" prop="price">
              <el-input-number :disabled="!editMode" v-model="childForm.price" :min="0" :precision="4" :controls="false" placeholder="请填写预计单价" style="width: 100%" @change="childNumberChange"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="采购总价" prop="amount">
              <el-input-number disabled v-model="childForm.amount" :min="0" :precision="4" :controls="false" placeholder="系统自动带出采购总价" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="">
        <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
        <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetPurchasePlanById,
  SavePurchasePlan,
  RejectPurchasePlan,
} from "@/api";
import { ProductionPlaceOptions } from "@/enum";
import MyUpload from "@/components/my-upload";
import SelectTree from "@/components/select-tree";
import SelectTable from "@/components/select-table";
import SelectUser from "@/components/select-user";
import ApproveInfo from "@/components/approve-info";
import AssetInfoEdit from "@/components/asset-into-edit";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {
    MyUpload,
    SelectTree,
    SelectUser,
    SelectTable,
    ApproveInfo,
    AssetInfoEdit,
  },
  data () {
    return {
      form: {},
      ProductionPlaceOptions: ProductionPlaceOptions,
      rules: {
        deptName: [
          { required: true, message: "所属科室不能为空", trigger: "blur" },
        ],
        purchaseUserName: [
          { required: true, message: "采购负责人不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      assetList: [],
      reject: RejectPurchasePlan,

      showSelectUser: false,
      defaultProps: {
        children: "children",
        label: "name",
      },
      ToPlaneData: null,
      // 子表
      childForm: {},
      childFormRules: {
        fixedAssetNo: [
          { required: true, message: "资产编号不能为空", trigger: "blur" },
        ],
        number: [
          { required: true, message: "采购总量不能为空", trigger: "blur" },
        ],
        price: [
          { required: true, message: "预计单价不能为空", trigger: "blur" },
        ],
      },
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      openSubformModal: false,
      optype: "default",
    };
  },

  created () { },
  mounted () {
    this.Init();
  },
  methods: {
    Init () {
      var query = this.$route.query;
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
        if (query.isToPlan) {
          this.ToPlaneData = JSON.parse(localStorage.ToPlaneData);
          this.form.details = this.ToPlaneData[0].details;
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
            this.sonNumChange(e);
          });
        }
        this.getType(
          query.deptClaimIds,
          query.deptClaimNos,
          query.deptApplyIds,
          query.deptApplyNos
        );
      }

      this.getDepts("");
      this.getUsersByDept("");
      this.getFixedAssetTrees("");
      this.getFixedAssetList();
      // this.$refs.AssetInfoEditRef.getFixedAssetList();
      // this.$refs.AssetInfoEditRef.getAssetCards();
    },
    getType (deptClaimIds, deptClaimNos, deptApplyIds, deptApplyNos) {
      if (deptClaimIds) {
        this.form.deptClaimIds = deptClaimIds;
        this.form.state = 1;
        this.optype = "claim";
      }
      if (deptClaimNos) {
        this.form.deptClaimNos = deptClaimNos;
      }
      if (deptApplyIds) {
        this.form.deptApplyIds = deptApplyIds;
        this.form.state = 2;
        this.optype = "apply";
      }
      if (deptApplyNos) {
        this.form.deptApplyNos = deptApplyNos;
      }
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetPurchasePlanById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getType(
          this.form.deptClaimIds,
          this.form.deptClaimNos,
          this.form.deptApplyIds,
          this.form.deptApplyNos
        );
        if (!this.form.details) {
          this.form.details = [];
        }
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        // this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      // this.form.details = this.$refs.AssetInfoEditRef.getDetails();
      // window.console.log(this.form);
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }

        SavePurchasePlan(this.form).then((res) => {
          localStorage.removeItem("ToPlaneData");
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        deptId: null,
        deptName: null,
        remark: "",
        assetSource: 0,
        assetId: "",
        specName: "",
        assetTypeId: "",
        number: 0,
        price: 0,
        amount: 0,
        productionPlace: 0,
        require: "",
        reason: "",
        state: 3,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        details: [],
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    deptChange (val) {
      this.form.deptId = val;
      this.getUsersByDept();
    },
    userChange (val) {
      let item = this.STATIC_Users.find((e) => e.id == val);
      if (item) {
        this.form.purchaseUserId = item.id;
        this.form.purchaseUserName = item.name;
        this.form.deptName = item.deptName;
        this.form.deptId = item.deptId;
      }
    },
    handleCheckChange (node) {
      if (node) {
        this.form.assetTypeId = node.id;
        this.form.assetTypeName = node.name;
      } else {
        this.form.assetTypeId = "";
        this.form.assetTypeName = "";
      }
    },

    autoTotalAmount (e) {
      // this.form.details = this.$refs.AssetInfoEditRef.getDetails();
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber;
      this.form.totalAmount = totalAmount;
    },
    toDecimal4 (row, column, cellValue, index) {
      return "￥" + this.toDecimal(cellValue, 4);
    },
    toDecimal2 (row, column, cellValue, index) {
      return this.toDecimal(cellValue, 2);
    },
    // 子表================================

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        assetId: "",
        fixedAssetNo: "",
        fixedAssetName: "",
        specName: "",
        assetCardIds: "",
        assetCardIdArr: [],
        assetCardNoArr: [],
        assetCardInfos: [],
        supplierId: "",
        supplierName: "",
        manufacturerId: "",
        manufacturerName: "",

        warehouseName: "",
        warehouseId: "",
        warehouseManagerId: "",
        warehouseManagerName: "",
        deptId: "",
        deptName: "",
        amount: 0,
        fees: 0,
        inventoryNumber: null,
        result: null,
        remark: null,
      };
    },
    /**
     * 明细表添加
     */
    handleAddChildForm () {
      if (!this.form.details) {
        this.form.details = [];
      }
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
    },
    /**
     * 明细表删除
     */
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
      this.autoTotalAmount();
    },
    /**
     * 子表选中行
     */
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    /**
     * 子表双击
     */
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      if (!this.childForm.assetCardInfos) {
        this.childForm.assetCardInfos = [];
      }
      this.$set(
        this.childForm,
        "assetCardIdArr",
        this.childForm.assetCardInfos?.map((e) => e.id)
      );
      this.$set(
        this.childForm,
        "assetCardNoArr",
        this.childForm.assetCardInfos?.map((e) => e.no)
      );
      // this.getAssetCards("");
    },
    /**
     * 关闭子弹窗
     */
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    /**
     * 继续添加
     */
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
    },
    /**
     * 子弹框提交
     */
    submitChildForm () {
      this.pushChildForm(true);
    },
    /**
     * 保存
     */
    pushChildForm (close) {
      if (this.editMode) {
        this.$refs["childForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.childForm.orgCode = sessionStorage.getItem('orgId')
          // this.capitalSourceChange()
          let item = this.form.details.find(
            (e) =>
              e.$index != this.childForm.$index &&
              e.assetId == this.childForm.assetId &&
              e.specName == this.childForm.specName &&
              e.fixedAssetName == this.childForm.fixedAssetName
          );

          if (item && !this.editChildren) {
            // 新增有重复项提示
            // Object.assign(item, this.childForm);
            this.$my_message(`当前采购信息已存在，请去子表编辑！`, "error");
            return;
          } else if (item && this.editChildren) {
            // 编辑且有重复项
            this.$my_message(`当前采购信息已存在，请去子表编辑！`, "error");
            return;
          } else if (!item && this.editChildren) {
            // 编辑
            item = this.form.details.find(
              (e) => e.$index == this.childForm.$index
            );
            Object.assign(item, this.childForm);
          } else {
            this.form.details.push(this.childForm);
          }

          this.form.details = [...this.form.details];
          this.autoTotalAmount();
          this.resetDetailFormData();
          if (close) {
            this.openSubformModal = false;
          }
        });
      } else {
        if (close) {
          this.openSubformModal = false;
        }
      }
    },
    childNumberChange () {
      if (this.childForm.maxAmount) {
        this.childForm.number =
          this.childForm.number > this.childForm.maxAmount
            ? this.childForm.maxAmount
            : this.childForm.number;
      }
      this.autoAmount();
      this.childForm.notReceivedNumber = this.childForm.number;
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(2) * 1;
    },
    cardChange (val) {
      if (val && val.length > 0) {
        let isAdd = false;
        // 判断是新增还是删除
        for (let i = 0; i < val.length; i++) {
          let item = this.childForm.assetCardInfos.find((e) => e.no == val[i]);
          if (item == null) {
            isAdd = true;
            let obj = this.STATIC_AssetCards.find((e) => e.no == val[i]);
            if (obj) {
              this.childForm.assetCardInfos.push(obj);
            }
            break;
          }
        }
        // 删除
        if (!isAdd) {
          this.childForm.assetCardInfos = this.childForm.assetCardInfos.filter(
            (i) => val.indexOf(i.no) != -1
          );
        }
        this.childForm.assetCardIds = this.childForm.assetCardInfos
          .map((item) => item.id)
          .join(";");
      } else {
        this.childForm.assetCardIds = "";
        this.childForm.assetCardInfos = [];
      }
    },
    getFixedAssetList (keyWord) {
      var param = { keyWord: keyWord };
      param.isFictitious = this.childForm.isFictitious;
      return this.GetStocksContainDetailByQuery(param);
    },
    getAssetCards (keyWord) {
      var param = {
        keyWord: keyWord,
        stockDetailId: this.childForm.stockDetailId,
        states: [0, 1],
      };
      this.getAssetCardsByQuery(param).then((res) => {
        if (
          this.childForm.assetCardInfos &&
          this.childForm.assetCardInfos.length > 0
        ) {
          this.childForm.assetCardInfos.forEach((item) => {
            let o = this.STATIC_AssetCards.find((e) => e.id == item.id);
            if (!o) {
              this.STATIC_AssetCards.push(item);
            }
          });
        }
      });
    },
    /**
     * 资产编号选择
     */
    selectAsset (row) {
      this.childForm = Object.assign(this.childForm, row, {
        // fixedAssetNo: row.no,
        // fixedAssetName: row.name,
        id: 0,
        assetCardIds: "",
        assetCardInfos: [],
        locationId: row.locationId,
        locationName: row.locationName,
        number: 1,
        stockNumber: row.number,
        maxAmount: row.number,
        price: 0,
        stockState: row.state,
      });
      // this.getAssetCards("");
      this.childNumberChange();
    },
    /**
     * 二级子表采购数量变化
     */
    sonNumChange (e) {
      var num = 0;
      e.details.forEach((t) => {
        num += t.number;
        t.price = (t.number * e.price).toFixed(2) * 1;
      });
      e.number = num;
      this.autoAmount2(e);
    },
    /**
     * 二级子表数量变化时计算子表金额，主表金额
     */
    autoAmount2 (e) {
      e.amount = (e.number * e.price).toFixed(2) * 1;
      var num = 0;
      var amount = 0;
      this.form.details.forEach((t) => {
        num += t.number;
        amount += t.amount;
        t.details.forEach((m) => {
          m.price = (m.number * t.price).toFixed(2) * 1;
        });
      });
      this.$set(this.form, "totalNumber", num);
      this.$set(this.form, "totalAmount", amount);
    },
    getUsersByDept (keyWord) {
      this.getDeptUsers(this.form.deptId, keyWord);
    },
    getRowClass (row, rowIndex) {
      let data = row.row;
      let res = [];
      if (data.details && data.details.length > 0) {
        res.push("row-expand-has");
      } else {
        res.push("row-expand-unhas");
      }
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
.two-list {
  margin-left: 3%;
  width: 97%;
  /deep/.el-table__body-wrapper {
    overflow-y: auto;
    max-height: 400px;
  }
}

/deep/.row-expand-unhas .el-table__expand-column {
  pointer-events: none;
}
/deep/.row-expand-unhas .el-table__expand-column .el-icon {
  visibility: hidden;
}
</style>
